import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Image, Stack } from "react-bootstrap";
import Lottie from "lottie-react";
import { useTranslation } from "react-i18next";

import "./WelcomePage.scss";
import PrimaryActionButton from "../../../components/Buttons/PrimaryActionButton/PrimaryActionButton";
import ShieldAnimation from "../../../assets/animations/shield-with-hand.json";
import ImageSigmaGamesLogo from "../../../images/sigma-games-logo.png";
import { OnboardingSteps } from "../../../utils/constants";
import useOnboardingSteps from "../../../hooks/useOnboardingSteps";
import useAuth from "../../../hooks/useAuth";
import useAnalytics from "../../../hooks/useAnalytics";
import OnboardingContainer from "../../../components/onboarding/OnboardingContainer/OnboardingContainer";
import { capitalizeFirstLetter } from "../../../utils/helpers";

function WelcomePage() {
  const { t } = useTranslation("common");
  const { userProfile } = useAuth();
  const username = userProfile?.username;
  const { goToStep } = useOnboardingSteps();
  const analytics = useAnalytics();

  useEffect(() => {
    analytics.sendWelcomeToSigmaGamesScreenEvent();
  }, [analytics]);

  const handleContinue = () => {
    analytics.sendStartGamingEvent();
    analytics.sendOnboardingCompleteEvent();
    goToStep(OnboardingSteps.PAYWALL);
  };

  return (
    <OnboardingContainer className="welcome-page">
      <div>
        <Link to="/">
          <Image src={ImageSigmaGamesLogo} width={115} />
        </Link>{" "}
      </div>

      <Stack className="align-items-center justify-content-end main-content">
        <div className="image-gamepad-container">
          <Lottie
            animationData={ShieldAnimation}
            loop={false}
            className="game-pad-animation"
          />
        </div>
        <Stack gap={2} className="text-content">
          <h1 className="welcome-text">
            {capitalizeFirstLetter(username ?? "")}
            {t("punctuations.comma")} {t("onboarding.welcome_to_sigma_games")}
            {t("punctuations.exclammation")}
          </h1>
          <h6 className="secondary-copy">
            {t(
              "onboarding.play_your_favorite_games_instantly_with_no_additional_installs_or_ads"
            )}
            {t("punctuations.full_stop")}
          </h6>
        </Stack>
        <PrimaryActionButton
          size="lg"
          text={t("lets_go") + t("punctuations.exclammation")}
          buttonClassName="lets-go-button lets-go-button-text"
          onClick={handleContinue}
        />
      </Stack>
    </OnboardingContainer>
  );
}

export default WelcomePage;
